import { useEffect, useRef } from 'react';

function useSkipFirstEffect(callback, deps) {
  const isFirstRender = useRef(true);

  useEffect(() => {
    console.log(deps, 'deps 009')
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    callback(); // Only call the callback on subsequent renders
  }, deps); // This effect depends on the passed dependencies (deps)
}

export default useSkipFirstEffect;
